import { apiFetch } from './client'

export type VaultAccess = 'RO' | 'RW'
export type VaultFileType = 'md' | 'pdf' | 'html' | 'code'

export interface VaultDto {
  id: string
  name: string
  abbr: string
  access: VaultAccess
  git: string
  clone: string
  sync: string
  syncMin: number
  ahead: number
  tokenSet: boolean
  archived?: boolean
  desc: string
}

export interface VaultTreeNodeDto {
  name: string
  path: string
  type: 'dir' | 'file'
  ann: string
  children?: VaultTreeNodeDto[]
}

export interface VaultFileDto {
  vaultId: string
  path: string
  type: VaultFileType
  content: string
  size: number
  lastCommit: string
}

export interface VaultCommitDto {
  hash: string
  subj: string
  author: string
  date: string
  unreleased: boolean
}

export interface VaultDiffDto {
  hash: string
  subj: string
  add: number
  del: number
  files: Array<{
    path: string
    lines: Array<{ gut: string; sign: string; code: string; kind: string }>
  }>
}

export function vaultPath(id: string, filePath?: string): string {
  const base = `/vaults/${encodeURIComponent(id)}`
  if (!filePath) return base
  return `${base}/${filePath.split('/').map(encodeURIComponent).join('/')}`
}

export function fetchVaults(): Promise<VaultDto[]> {
  return apiFetch<VaultDto[]>('/api/vaults')
}

export function fetchVaultTree(id: string, depth = 2): Promise<VaultTreeNodeDto[]> {
  return apiFetch<VaultTreeNodeDto[]>(`/api/vaults/${encodeURIComponent(id)}/tree`, {
    query: { depth },
  })
}

export function fetchVaultFile(id: string, filePath: string): Promise<VaultFileDto> {
  return apiFetch<VaultFileDto>(`/api/vaults/${encodeURIComponent(id)}/file`, {
    query: { path: filePath },
  })
}

export function fetchVaultCommits(id: string, filePath = ''): Promise<VaultCommitDto[]> {
  return apiFetch<VaultCommitDto[]>(`/api/vaults/${encodeURIComponent(id)}/commits`, {
    query: { path: filePath },
  })
}

export function fetchVaultDiff(id: string, hash: string): Promise<VaultDiffDto> {
  return apiFetch<VaultDiffDto>(`/api/vaults/${encodeURIComponent(id)}/diff`, {
    query: { hash },
  })
}
